import type { Notification } from '@/services/inAppNotificationService';

/**
 * Single source of truth for where a notification should take you inside the
 * unified Social hub. Boards read their thread from the `?thread=` param.
 */
export function notificationTarget(notification: Pick<Notification, 'type' | 'data'>): string {
  const data = (notification.data ?? {}) as Record<string, any>;
  const thread = data.threadId ? `/social/boards?thread=${data.threadId}` : '/social/boards';

  switch (notification.type) {
    case 'thread_reply':
    case 'mention':
    case 'thread_featured':
      return thread;
    case 'xp_gift':
      return data.insightId ? `/insights/${data.insightId}` : thread;
    case 'badge_earned':
      return '/profile';
    case 'connection_request':
      return data.username ? `/u/${data.username}` : '/social/members';
    case 'dm_message':
      return data.conversationId ? `/social/mail/${data.conversationId}` : '/social/mail';
    case 'streak_milestone':
    case 'weekly_goal_met':
      return '/social/boards';
    default:
      return '/social';
  }
}
